export const MAX_PASSPORT_NUMBER_LENGTH = 12;
